import { render, staticRenderFns } from "./etf.vue?vue&type=template&id=7dac9fa2&scoped=true"
import script from "./etf.vue?vue&type=script&lang=js"
export * from "./etf.vue?vue&type=script&lang=js"
import style0 from "./etf.vue?vue&type=style&index=0&id=7dac9fa2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dac9fa2",
  null
  
)

export default component.exports